<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading" class="block min-w-0" style="container: variety-list / inline-size;">
    <div class="[@container_variety-list_(max-width:30rem)]:px-0 [@container_variety-list_(max-width:30rem)]:[&>.mr-5]:mr-0 w-full px-10 py-7 bg-tileLight dark:bg-[#363636] rounded-lg overflow-x-auto">
        <div class="[@container_variety-list_(max-width:56rem)]:flex-wrap [@container_variety-list_(max-width:56rem)]:gap-4 [@container_variety-list_(max-width:56rem)]:[&>p]:[overflow-wrap:anywhere] flex flex-row justify-between items-center mr-5">
            <p class="text-[16px] font-bold dark:text-white text-[#030308]">{{centerDetails.regCode}}
                {{centerDetails.centerName}}</p>
            <div class="[@container_variety-list_(max-width:56rem)]:max-w-full [@container_variety-list_(max-width:56rem)]:[&_input]:min-w-0 [@container_variety-list_(max-width:56rem)]:[&_button]:shrink-0 [@container_variety-list_(max-width:30rem)]:w-full flex items-center rounded-full ml-auto shrink-0 max-w-full px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
                <input type="text" placeholder="Search by Crop / Variety Name" [(ngModel)]="searchText"
                    (keyup.enter)="onSearchVarity()" (keyup.esc)="offSearchVarity()"
                    (ngModelChange)="searchText = $event.trimStart()"
                    class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                    (click)="onSearchVarity()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                    </svg>
                </button>
                <button *ngIf="searchText" type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="offSearchVarity()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>

        <div *ngIf="hasData && isInitialData"
            class="mt-8 mr-5 border-gray-100 border-[2px] overflow-x-auto rounded-lg dark:border-[#202021]">
            <table class="w-full min-w-max divide-y-2 overflow-hidden ">
                <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                    <tr>
                        <th class=" px-6 py-3 text-center  font-medium">ITEM ({{cropCount < 10 ? '0' + cropCount :
                                cropCount}})</th>
                        <th class=" px-6 py-3 text-left  font-medium">Crop</th>
                        <th class=" px-6 py-3 text-left  font-medium">Variety</th>
                        <th class=" px-6 py-3 text-left  font-medium">Status</th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                    <!-- <tr
                        *ngFor="let item of priceListArr | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let i = index"> -->
                    <tr
                        *ngFor="let item of cropsArr | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems }; let i = index">
                        <td class="px-6 py-3 text-center text-[#000000] dark:text-[#C5C5C5]">
                            {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i + 1)
                                : (((page - 1) * itemsPerPage) + i + 1) }} </td>
                        <td class="px-6 py-3  text-[#000000] dark:text-[#C5C5C5]">{{item.cropNameEnglish}}</td>
                        <td class="px-6 py-3  text-[#000000] dark:text-[#C5C5C5]">{{item.varietyNameEnglish}}</td>
                        <td class="px-6 py-3  text-[#000000] dark:text-[#C5C5C5]">
                            <label class="inline-flex items-center cursor-pointer">
                                <input type="checkbox" class="sr-only peer" [ngModel]="item.isAssign === 1"
                                    (click)="onAdd(item.isAssign, item.cropId)"
                                    (ngModelChange)="item.isAssign = $event ? 1 : 0" name="isAssign" />
                                <div
                                    class="relative w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600">
                                </div>
                            </label>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="hasData && isInitialData"
            class="flex justify-end items-center my-5 mr-5 pt-3 dark:bg-[#1D1D1F] text-right">
            <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true" [previousLabel]="'Previous'"
                [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'" [screenReaderPageLabel]="'page'"
                [screenReaderCurrentLabel]="'Youre on page'">
            </pagination-controls>
        </div>

        <div *ngIf="!hasData && isInitialData"
            class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] rounded-lg mt-6 dark:text-black">
            <p class="text-[#494949] my-6 dark:text-[#FFFFFF]">--No Data Availabale--</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-black" />
        </div>

        <div *ngIf="!isInitialData"
            class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg mt-6 dark:text-black">
            <p class="text-[#494949] dark:text-[#FFFFFF]">Currently, the market price for this centre has not been
                uploaded.</p>
            <p class="text-[#494949] mb-6 dark:text-[#FFFFFF]">Please wait!!</p>
            <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-black" />
        </div>

    </div>
</div>
